<script context="module">
  import { TAGS } from './utils'

  export { TAGS }
</script>

<script>
  import { GridContainer, GridColumn, Separator, Header, Text } from '../..'

  import { getClass } from './utils'

  export let withMargin = true
  export let title = undefined
  export let isTitleLarge = false
  export let subTitle = undefined
  export let titleTag = undefined

  $: className = getClass({ className: $$props.class || '' })
</script>

<GridContainer>
  <GridColumn width={0} widthMiddle={1} />
  <GridColumn widthMiddle={10} class={className}>
    {#if withMargin}
      <Separator key={20} size={Separator.SIZES.LARGE} />
      {#if title !== undefined}
        <Header tag={titleTag} size={isTitleLarge ? Header.SIZES.LARGE : undefined}>{title}</Header>
        {#if subTitle !== undefined}
          <Separator key={15} size={Separator.SIZES.SMALLEST} />
          <Text size={Text.SIZES.LARGE}>{subTitle}</Text>
        {/if}
        <Separator key={10} size={Separator.SIZES.SMALL} />
      {/if}
    {/if}
    <Separator key={15} size={Separator.SIZES.SMALL} />
  </GridColumn>
  <GridColumn width={0} widthMiddle={1} />
</GridContainer>
